var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-page"},[_c('div',{staticClass:"inner-content"},[_c('div',[_c('img',{attrs:{"src":require("../../../assets/svg/logo-stenci.svg"),"width":"150","alt":"stenci"}})]),_c('small',[_vm._v("Saíndo do sistema, aguarde...")])])])
}]

export { render, staticRenderFns }